module.exports = __webpack_public_path__ + "img/album18_37.bc2c37ff.jpg";